import { render } from "./FengYQ.vue?vue&type=template&id=54e2e888&scoped=true"
import script from "./FengYQ.vue?vue&type=script&lang=js"
export * from "./FengYQ.vue?vue&type=script&lang=js"

import "./FengYQ.vue?vue&type=style&index=0&id=54e2e888&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e2e888"]])

export default __exports__